import { Component, OnInit } from '@angular/core';
import { LoginService } from './login.service';
import { SessionStorage } from 'ngx-webstorage';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material';
import { Login, UserDetails } from './login';
import { ApplicationConfig } from '../../utils/models/config';
import { ConfigService } from '../../utils/services/config.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { BroadcastService, MsalService } from "@azure/msal-angular";
import { Subscription } from "rxjs";
@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
})
export class LoginComponent implements OnInit {
  private _initialRoutes = {
    ADMIN: "/admin/dashboard",
    EMP: "/employee/dashboard",
    RM: "/rm/dashboard",
  };
  @SessionStorage("user") public loggedInUser;
  @SessionStorage("userObj") public userObj;
  @SessionStorage("x-access-token") public token;
  @SessionStorage("config") public config;

  public login = new Login({});
  public loginConfig = null;
  public currentYear;

  constructor(
    private authService: MsalService,
    public loginService: LoginService,
    public configService: ConfigService,
    public router: Router,
    public snackBar: MatSnackBar,
    private spinnerService: Ng4LoadingSpinnerService,
    private broadcastService: BroadcastService,
  ) { }

  ngOnInit() {
    const d = new Date();
    this.currentYear = d.getFullYear();
    this.token = null;
    this.userObj = null;
    this.userLogin();
  }  

  
/* Login With Microsoft-Azure */
  userLogin() {
    const isIE =
      window.navigator.userAgent.indexOf("MSIE ") > -1 ||
      window.navigator.userAgent.indexOf("Trident/") > -1;

    if (isIE) {
      this.authService.loginRedirect();
    } else {
      this.authService.loginRedirect();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/common/login/login.component.ts